import { API } from "aws-amplify";
import { listUnitPlans } from "~/graphql/queries";
import { GRAPHQLFilters, LoaderData } from "~/types";
import { getGraphqlFilters } from "~/utils";
import * as APITypes from "~/API";

export const getUnitPlanList = async ({
  ownerID,
  ownerType,
  propertyID,
  includeDeleted = "exclude",
}: {
  ownerID?: string;
  ownerType?: APITypes.OwnerType;
  propertyID?: string;
  includeDeleted?: "all" | "exclude" | "only";
}): Promise<LoaderData<APITypes.UnitPlan[]>> => {
  const filters: GRAPHQLFilters = getGraphqlFilters({
    ownerID,
    ownerType,
    propertyID,
  });

  if (includeDeleted === "exclude") {
    filters._deleted = { ne: true };
  } else if (includeDeleted === "only") {
    filters._deleted = { eq: true };
  }

  let items: APITypes.UnitPlan[] = [];
  let nextToken: string | null | undefined = undefined;

  try {
    do {
      const response = (await API.graphql({
        query: listUnitPlans,
        variables: { filter: filters, nextToken, limit: 200 },
      })) as { data?: { listUnitPlans?: { items?: (APITypes.UnitPlan | null)[]; nextToken?: string | null } } };

      const page = response.data?.listUnitPlans?.items?.filter(
        (p): p is APITypes.UnitPlan => p != null,
      ) ?? [];
      items = items.concat(page);
      nextToken = response.data?.listUnitPlans?.nextToken;
    } while (nextToken);

    return { success: true, data: items };
  } catch (error) {
    console.error("getUnitPlanList failed", error);
    return { success: false, data: [], error: String(error) };
  }
};
